import React, { createContext, useContext } from 'react';

const TecRmiTypeDetailsContext = createContext(null);

export const TecRmiTypeDetailsProvider = ({ children }) => {
  const [typeDetails, setTypeDetails] = React.useState({})

  const typeDetailsIsEmpty = () => {
    return Object.values(typeDetails).every(value => value === null)
  }

  return (
    <TecRmiTypeDetailsContext.Provider value={{typeDetails, setTypeDetails, typeDetailsIsEmpty}}>
      {children}
    </TecRmiTypeDetailsContext.Provider>
  );
};

export const useTecRmiTypeDetails = () => {
  return useContext(TecRmiTypeDetailsContext);
};